export default theme => ({
  dropdown: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  disableUppercase: {
    textTransform: 'none'
  }
})
